<template>
  <vx-card title="سبد خرید">
    <div v-if="shoppingCardInfo.products.length <= 0" class="text-center">سبد خرید شما خالی است</div>
    <template v-else>
      <div v-if="cartVisibility" style="overflow: scroll; max-height: 300px;">
        <shop-item v-for="product in shoppingCardInfo.products" :product="product" :key="product.id"
          @add="$emit('add', product.product)" @remove="$emit('remove', product.product)"></shop-item>
        <vs-divider></vs-divider>
      </div>
      <div class="row">
        <div>
          <p class="final-price">تعداد:‌ <span class="price">{{ shoppingCardProductsCount }}</span></p>
          <p class="final-price">قیمت نهایی: <span class="price">{{
              shoppingCardInfo.finalPrice.toString().numberFormat()
          }}</span> ریال</p>
        </div>
        <vs-button @click="toggleCartVisibility()" color="primary" block>نمایش سبد</vs-button>
      </div>
      <vs-divider></vs-divider>
      <vs-button @click="$emit('create-order')" color="primary" class="mt-5" block icon-pack="feather" icon="icon-play">
        ادامه فرآیند</vs-button>
    </template>
  </vx-card>
</template>

<script>
import ShopItem from './ShopItem.vue';

export default {
  name: "ShoppingCard",
  data() {
    return {
      cartVisibility: false,
    };
  },
  computed: {
    shoppingCardProductsCount() {
      let count = 0;
      this.shoppingCardInfo.products.forEach((item) => {
        count += item.unit;
      });
      return count;
    },
  },
  props: {
    shoppingCardInfo: {
      required: true,
      type: Object
    }
  },
  components: {
    ShopItem
  },
  methods: {
    toggleCartVisibility() {
      this.cartVisibility = !this.cartVisibility;
    }
  }
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.final-price {
  font-size: 16px;
  color: #141E47;

  .price {
    font-weight: 800;
  }
}
</style>
